import './FormCreator.scss';
import React from "react";

const FormCreator = ({
  children,
  dataModel,
  formClassName = "",
  formModel,
  handleFormData,
  handleInputData,
  editMode = false
}) => {
  const [data, setData] = React.useState(dataModel);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
    handleInputData && handleInputData(name, value);
  };

  const handleSubmitForm = event => {
    event.preventDefault();
    handleFormData && handleFormData(data);
  };

  return (
    <form
      className={`FormCreator ${formClassName}`}
      onSubmit={handleSubmitForm}
    >
      <fieldset>
        {editMode ? (
          <React.Fragment>
            {formModel &&
              formModel.map((element, index) => {
                const Tag = element.tag;
                return (
                  <label key={index}>
                    {element.title && element.title}
                    {
                      Tag &&
                      <Tag
                        onChange={handleInputChange}
                        name={element.name}
                        type={element.type}
                        placeholder={element.placeholder}
                        defaultValue={data[element.name]}
                        {...element.attributes}
                      />
                    }
                    {
                      element.component &&
                      element.component
                    }
                  </label>
                );
              })}
          </React.Fragment>
        ) : (
            <React.Fragment>
              {formModel &&
                formModel.map((element, index) => {
                  const Tag = element.tag;
                  return (
                    <label key={index}>
                      {element.title && element.title}
                      {
                        Tag &&
                        <Tag
                          onChange={handleInputChange}
                          type={element.type}
                          name={element.name}
                          placeholder={element.placeholder}
                          defaultValue={data[element.name]}
                          {...element.attributes}
                        />
                      }
                      {element.component &&
                        element.component
                      }
                    </label>
                  );
                })}
            </React.Fragment>
          )}
        {children}
      </fieldset>
    </form>
  );
};
export default FormCreator;


// WEBPACK FOOTER //
// ./src/App/components/FormCreator/FormCreator.jsx